import templates from "components/templates/templates";

const getTemplateComponentByKey = (key) =>
  (templates.find((template) => template.key === key) || { Component: () => null }).Component;

export default getTemplateComponentByKey;
